
export const incidenceRateMixin = {

    computed: {

        incidenceRate() {
            if (this.project.completed_count > 0) {
                return Math.round(this.project.completed_count / (this.project.completed_count + this.incidenceTerminatedCount) * 100);
            }
            return 0;
        },

        incidenceColor() {
            if (this.incidenceRate === 0) return 'grey';
            if (this.project.estimated_incidence_rate === 0 || this.incidenceAlarmPercent === 0) return 'rgba(0,0,0,0)'; // Transparent

            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent) return '#A83939'; // red
            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent * 0.66) return '#EF6C00'; // orange darken-3
            if (this.incidenceDeviationPercent > this.incidenceAlarmPercent * 0.33) return '#FF8F00'; // amber darken-3
            if (this.incidenceDeviationPercent > 0) return '#F9A825'; // yellow darken-3

            return 'green';
        },

        incidenceDeviationPercent() {
            if (this.project.estimated_incidence_rate > 0) {
                if (this.incidenceRate < this.project.estimated_incidence_rate) {
                    return 100 - Math.round(this.incidenceRate / this.project.estimated_incidence_rate  * 100);
                }
            }
            return 0;
        },

        incidenceAlarmPercent() {
            return 100 - this.$store.state.PanelSettings.settings.incidence_alarm_threshold;
        },

        incidenceTerminatedCount() {
            return this.project.profile_count +
                this.project.quota_count +
                this.project.profile_count +
                this.project.quality_count +
                this.project.duplicate_count;
        },
    },
};